const logoByTypeAndName = (type, name) => ({
  logo: `${process.env.REACT_APP_ASSETS_BASE_URL}/${type}/${name}.svg`,
  logoDark: `${process.env.REACT_APP_ASSETS_BASE_URL}/${type}/${name}_dark.svg`
});

const logoByCollector = code => {
  const type = code === "CASH" ? "modes" : "collectors";

  return logoByTypeAndName(type, code);
};

const logoByMerchant = code => logoByTypeAndName("merchants", code);

export { logoByCollector, logoByMerchant };
